import { render, staticRenderFns } from "./customerOperatorAccountInvoice.vue?vue&type=template&id=cb201af8&scoped=true"
import script from "./customerOperatorAccountInvoice.vue?vue&type=script&lang=js"
export * from "./customerOperatorAccountInvoice.vue?vue&type=script&lang=js"
import style0 from "./customerOperatorAccountInvoice.vue?vue&type=style&index=0&id=cb201af8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb201af8",
  null
  
)

export default component.exports